import 'regenerator-runtime/runtime';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import * as SearchActionType from './constants';
import * as NotifyActionType from 'Notification/constants';
import { searchHomeowners, searchRequestForService, searchWorkOrders } from './api';

export function* searchHomeownersAsync(action) {

  const result = yield call(searchHomeowners, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: SearchActionType.SEARCH_HOMEOWNER_SUCCESS,
      data: {
        data: result.data,
        params: action.params
      }
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* searchWorkOrdersAsync(action) {

  const result = yield call(searchWorkOrders, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: SearchActionType.SEARCH_WORK_ORDERS_SUCCESS,
      data: {
        data: result.data,
        params: action.params
      }
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* searchRequestForServiceAsync(action) {

  const result = yield call(searchRequestForService, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: SearchActionType.SEARCH_REQUEST_FOR_SERVICE_SUCCESS,
      data: {
        data: result.data,
        params: action.params
      }
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export default function* WatchGlobalSearch() {
  yield all([
    takeLatest(SearchActionType.SEARCH_HOMEOWNER_ASYNC, searchHomeownersAsync),
    takeLatest(SearchActionType.SEARCH_WORK_ORDERS_ASYNC, searchWorkOrdersAsync),
    takeLatest(SearchActionType.SEARCH_REQUEST_FOR_SERVICE_ASYNC, searchRequestForServiceAsync)
  ]);
}



// WEBPACK FOOTER //
// ./src/Search/saga.js